import { createTypes } from "reduxsauce";

export default createTypes(
    `
    SHOW_TOAST
    HIDE_TOAST
`,
    {
        prefix: "toastmessage/"
    }
);
